module.exports = __webpack_public_path__ + "static/concierge-service-c02bbd607fd784b763dfb436262ff379.jpg";